import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router-dom';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import addReportActions from '../../store/add-report/action-creators/index';
import AddReportForType from './AddReportForType';

class AddReportContainer extends Component {
  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    this.props.loadAddReportContainer();
  }

  componentWillUnmount() {
    this.props.unmountAddReportContainer();
  }

  render() {
    return (
      <LoadingOverlay isLoading={this.props.isLoading}>
        <div>
          <Route component={AddReportForType} exact path="/add-report/:forType" />
        </div>
      </LoadingOverlay>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return { isLoading: state.addReport.isLoading.length > 0 };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadAddReportContainer: () => {
      return dispatch(addReportActions.loadAddReportContainer());
    },
    unmountAddReportContainer: () => {
      return dispatch(addReportActions.unmountAddReportContainer());
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddReportContainer));
